import Vue from 'vue'
import VueRouter from 'vue-router'

import { mapGetters } from 'vuex'
import store from './store'

import ageConfirmation from './components/partials/age-confirmation.vue'
import popupGame from './components/partials/popup-game.vue'
import Einkehren from './components/einkehren.vue'
import Biere from './components/biere.vue'

import BierkulTour from './components/bierkul-tour.vue'
import KulturGenuss from './components/kultur-genuss.vue'
import BayronMan from './components/bayron-man.vue'
import Game from './components/game.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        { path: '/',                component: ageConfirmation },
        { path: '/einkehren',       component: Einkehren },
        { path: '/biere',           component: Biere },
        { path: '/bierkul-tour',    component: BierkulTour },
        { path: '/kultur-genuss',   component: KulturGenuss },
        { path: '/bayron-man',      component: BayronMan },
        { path: '/gewinnspiel',     component: Game }
    ],
    mode: 'history',
    linkActiveClass: 'is-current'
})


// router.beforeEach((to, from, next) => {
//
//     if( to.path !== from.path ) {
//
//         if( store.state.ageConfirmed ) {
//             next()
//         }
//         else {
//             //router.push({ path: '/biere', query: { from } })
//             next({ path: '/', query: { confirm: to.path.slice(1) } }) // remove slash
//             //next('/')
//         }
//     }
//     else {
//         next()
//     }
//
//
// })




new Vue({
    router,
    store,
    components: { popupGame },

    beforeRouteEnter(to, from, next) {


        console.log(this);
        if( ageConfirmed ) {
            next()
        }
        else {
            router.push({ path: '/', query: { from } })
        }

    },


    computed: mapGetters([ 'ageConfirmed' ]),

    el: '#app',
    data: {
        askAge: true
    },

    methods: {

        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input]
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0 // current path starts with this path string
            })
        }

    }


})



// WEBPACK FOOTER //
// ./src/js/main.js